import type * as React from 'react';

import { useMetaConfig } from '@xing-com/hub';

import { LegalFooterStandaloneInner } from './legal-footer-standalone-inner';

export const LegalFooterStandaloneLoggedout: React.FC = () => {
  const { data } = useMetaConfig();

  return data?.navigation.loggedOutlegalFooter ? (
    <LegalFooterStandaloneInner config={data.navigation.loggedOutlegalFooter} />
  ) : null;
};
